import BulkOrderGiftCardsEditPage from '../../../components/pages/bulk_order/gift_cards/BulkOrderGiftCardsEditPage.vue'
export default {
  components: { BulkOrderGiftCardsEditPage }
}
